<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active text-capitalize">{{currentPage}}</li>
      </ol>
      <h1 class="page-title">{{ $t('team.labels.createTeam') }}</h1>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <form v-on:submit.prevent="onSubmit" autocomplete="off">
            <div class="row">
              <div class="col-md-6 col-xs-12">
                <alert v-show="showAlert"
                  alertClass="m-b-25 alert-dismissible"
                  v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
                  v-bind:iconClass="`${ (successResponse) ? 'md-check' : 'md-close' }`">
                  <span v-if="successResponse">{{successResponse}}</span>
                  <span v-else-if="errorResponse">{{errorResponse}}</span>
                </alert>
                <div class="form-section">
                  <h4 class="title">{{ $t("team.title") }}</h4>
                  <form-group v-bind:error="formErrors.first('team')">
                    <label for="team">{{ $t('team.displayName.labels') }}</label>
                    <span  class="guideline-block">{{ $t('team.displayName.textGuide') }}</span>
                    <input type="text" class="form-control input-lg" id="team" :placeholder="$t('team.displayName.labels')" v-model="user.team">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('namespace')">
                    <label for="namespace">{{ $t('team.url.labels') }}</label>
                    <span class="help-block m-t-0">{{ $t('team.url.textGuide') }}</span>
                    <div class="input-group">
                      <div class="input-group-addon">{{`${baseURL}/`}}</div>
                      <input type="text" class="form-control input-lg" id="namespace" :placeholder="$t('team.url.labels')" v-model="user.namespace">
                    </div>
                  </form-group>
                  <form-group v-bind:error="formErrors.first('type')" v-if="showTeamType">
                    <label for="role">{{ $t('team.type.labels') }}</label>
                    <div class="radio-custom radio-primary">
                      <input type="radio" value="normal-team" v-model="user.type">
                      <label for="inputRadiosUnchecked">Normal Team</label>
                    </div>
                    <div class="radio-custom radio-primary">
                      <input type="radio" value="reseller" v-model="user.type">
                      <label for="inputRadiosUnchecked">Reseller</label>
                    </div>
                    <div class="radio-custom radio-primary">
                      <input type="radio" value="sub-team" v-model="user.type">
                      <label for="inputRadiosUnchecked">Sub Team of Reseller</label>
                    </div>
                  </form-group>
                  <form-group v-if="user.type === 'sub-team' && showTeamType">
                    <label for="team">Choose Reseller <span class="red-600">*</span></label>
                    <v-select v-model="currentResellerTeam" :options="filterItems"></v-select>
                  </form-group>
                </div>
                <div class="form-section">
                  <h4 class="title">{{ $t('account.labels.account') }}</h4>
                  <form-group v-bind:error="formErrors.first('displayname')" autocomplete="false">
                    <label for="name">{{ $t('account.labels.displayName') }}</label>
                    <input type="text" class="form-control input-lg" :placeholder="$t('account.labels.displayName')" v-model="user.displayname">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('email')">
                    <label for="email">{{ $t('account.labels.email') }}</label>
                    <input type="email" class="form-control input-lg"  :placeholder="$t('account.labels.email')" v-model="user.email" autocomplete="false">
                  </form-group>
                  <form-group v-bind:error="formErrors.first('password')">
                    <label for="password">{{ $t('account.labels.password') }}</label>
                    <input type="password" class="form-control input-lg" :placeholder="$t('account.labels.password')" v-model="user.password">
                  </form-group>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-xs-12">
                <button type="submit" class="btn btn-success" :disabled="isSubmiting" v-bind:class="{ 'btn-default': isSubmiting }">
                  <div class="loader vertical-align-middle loader-circle loader-form" v-if="isSubmiting"></div> Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import { mapGetters } from 'vuex';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';
import vSelect from 'vue-select';

export default {
  components: {
    FormGroup,
    vSelect,
    Alert,
  },
  watch: {
    'user.team': function() {
      if (this.formErrors.has('team')) {
        this.formErrors.remove('team');
      }
    },
    'user.namespace': function() {
      if (this.formErrors.has('namespace')) {
        this.formErrors.remove('namespace');
      }
    },
    'user.email': function() {
      if (this.formErrors.has('email')) {
        this.formErrors.remove('email');
      }
    },
    'user.displayname': function() {
      if (this.formErrors.has('displayname')) {
        this.formErrors.remove('displayname');
      }
    },
    'user.password': function() {
      if (this.formErrors.has('password')) {
        this.formErrors.remove('password');
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
    baseURL: () => process.env.BASE_URL,
    filterItems: function () {
      const temp = [];
      this.teams.forEach((item) => {
        temp.push({ label: item.namespace, value: item.id });
      });
      return temp;
    },
    showTeamType: function() {
      if (this.currentUser.team.is_superadmin) {
        return true;
      } else {
        return false;
      }
    },
    currentPage: function () {
      if (this.currentUser.team.is_superadmin) {
        return 'admin';
      } else if (this.currentUser.team.is_reseller) {
        return 'reseller';
      }
    },
  },
  data: function () {
    return {
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      teams: [],
      currentResellerTeam: '',
      isSubmiting: false,
      user: {
        team: null,
        namespace: null,
        email: null,
        displayName: null,
        password: null,
        type: 'normal-team',
      },
    };
  },
  created: function() {
    this.isLoading = true;
    this.validator = new Validator();
    this.validator.attach('team', 'required|max:72', { prettyName: 'Team Display name' });
    this.validator.attach('namespace', 'required|namespace|min:3|max:32', { prettyName: 'Team URL' });
    this.validator.attach('email', 'required|email');
    this.validator.attach('displayname', 'required', { prettyName: 'display name' });
    this.validator.attach('password', 'required|min:6');

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  mounted: function() {
    if (this.currentPage === 'admin') {
      this.fetchTeams();
    }
  },
  methods: {
    onSubmit: function () {
      this.submitForm = false;
      this.validator.validateAll({
        team: this.user.team,
        namespace: this.user.namespace,
        email: this.user.email,
        displayname: this.user.displayname,
        password: this.user.password,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;

        axios.post(`/api/teams`, {
          name: this.user.team,
          namespace: this.user.namespace,
          email: this.user.email,
          display_name: this.user.displayname,
          password: this.user.password,
          is_reseller: this.user.type === 'reseller' ? 1 : 0,
          reseller_id: this.user.type === 'sub-team' ? this.currentResellerTeam.value : 0,
        })
        .then(() => {
          this.successResponse = this.$t('team.response.success');
          this.errorResponse = null;
          this.showAlert = true;
          this.isSubmiting = false;
          const redirectUrl = `/${this.$route.params.namespace}/${this.currentPage}/teams/`;

          setTimeout(() => {
            this.$router.push(redirectUrl);
          }, 2000);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errorResponse = this.$t('team.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('team.response.defaultFailed');
          }
          this.showAlert = true;
          this.isSubmiting = false;
        });
      })
      .catch(() => {
      });
    },
    fetchTeams: function() {
      const url = `/api/teams?accept=reseller`;

      axios.get(url)
      .then((response) => {
        this.teams = response.data.data;
        this.isLoading = false;
      })
      .catch(() => {

      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// TeamCreator.vue?183d782d